module.exports = __webpack_public_path__ + "img/Tim James.eb9869da.jpg";